import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';
import {ICapability} from "@/contracts/CapabilityContract";

export interface CapabilityDataType extends AbstractDataSourceType, ICapability {

}

export class CapabilityDataSource extends DataSource {
    public data: CapabilityDataType[];

    constructor(capabilities: ICapability[]) {
        super(capabilities);
    }
}
